import { useState, useEffect, useCallback } from 'react';

const DEFAULT_STORAGE_KEY = 'sidebar-collapsed';

export function useSidebarCollapse(storageKey: string = DEFAULT_STORAGE_KEY) {
  const [isCollapsed, setIsCollapsed] = useState(() => {
    // Initialize from localStorage
    if (typeof window !== 'undefined') {
      const stored = localStorage.getItem(storageKey);
      return stored === 'true';
    }
    return false;
  });

  // Persist to localStorage on change
  useEffect(() => {
    localStorage.setItem(storageKey, String(isCollapsed));
  }, [isCollapsed, storageKey]);

  const toggleCollapse = useCallback(() => {
    setIsCollapsed((prev) => !prev);
  }, []);

  const collapse = useCallback(() => {
    setIsCollapsed(true);
  }, []);

  const expand = useCallback(() => {
    setIsCollapsed(false);
  }, []);

  return {
    isCollapsed,
    toggleCollapse,
    collapse,
    expand,
  };
}
